import { getUrlParameter, initDefaultSelect2, makeKTBlock, makeSwal } from '../../general/functions';
import { BASE_URL } from '../../general/variables';

const utmMappingListener = () => {
  // First setup
  makeKTBlock('#utmmappingCard');
  $.ajax({
    url: `${BASE_URL}C_Event/getEventUTMMapping?eid=${getUrlParameter('id')}`,
    type: 'get',
    dataType: 'JSON',
    success: function (resp) {
      const { header, message, status, code, data } = resp;
      makeKTBlock('#utmmappingCard', 'hide');

      if (code == 234) {
        $('#btnDupeUTMMapping').show();
        $('#btnResetUTMMapping').hide();
        return;
      }

      $('#btnDupeUTMMapping').hide();
      $('#btnResetUTMMapping').show();

      // Process inject UTM Mapping if exist
      $.each(data, function (i, dt) {
        // Clone category container
        let $dupeElemUTM = $('.defaultUTMContainer').clone();
        $dupeElemUTM.removeClass('defaultUTMContainer').addClass('repeaterUTMContainer').attr('data-category-index', i).show();

        // Show remove button
        $dupeElemUTM.find('.removeContainer').show().find('button').show();

        // Fill category-level fields
        $dupeElemUTM.find(`input[name="mappingUTMID[]"]`).val(dt.UTM_ID ?? '');
        $dupeElemUTM.find(`input[name="mappingName[]"]`).val(dt.CATEGORY_NAME);

        // Append category to DOM before adding pattern values
        $('.addContainer').before($dupeElemUTM);

        // Prepare pattern field & values
        let patternFieldArr = dt.PATTERN_FIELD.split('|');
        let patternValueArr = dt.PATTERN_VALUE.split('|');
        let $patternTemplate = $('.defaultPatternContainer').clone();
        $patternTemplate.removeClass('defaultPatternContainer').addClass('repeaterPatternContainer').show();

        // Append pattern value to container
        $.each(patternValueArr, function (subIndex, pv) {
          let $patternElem;

          $patternElem = $patternTemplate.clone();

          // Show remove button if needed
          $patternElem.find('.removePatterContainer').show().find('button').show();
          $dupeElemUTM.find('.defaultPatternValueContainer').append($patternElem);

          // Set value and correct name
          $patternElem.find('select[name="mappingPatternField[][]"]').addClass('select2MappingPatternField').val(patternFieldArr[subIndex]).trigger('change');
          $patternElem.find('input[name="mappingPatternValue[][]"]').val(pv);
        });

        // Final pass: rename ALL mappingPatternField & mappingPatternValue inputs in this category
        $dupeElemUTM.find('.select2MappingPatternField').each(function () {
          $(this).attr('name', `mappingPatternField[${i}][]`);
          $(this).select2({ placeholder: $(this).data('placeholder'), minimumResultsForSearch: Infinity });
        });

        $dupeElemUTM.find('input[name^="mappingPatternValue["]').each(function () {
          $(this).attr('name', `mappingPatternValue[${i}][]`);
        });
      });
    },
    error: function (data) {
      const { header, message, status } = data.responseJSON;
      makeKTBlock('#utmmappingCard', 'hide');
      makeSwal(header, message, status);
    },
  });

  //   Listener Pattern value
  $(document).on('click', '.btnAddPatternValue', function (e) {
    e.preventDefault();
    makeKTBlock('#utmmappingForm');

    let $catBlock = $(this).closest('.repeaterUTMContainer');
    let catIndex = $catBlock.data('category-index');

    let $patternTemplate = $('.defaultPatternContainer');
    let $newPattern = $patternTemplate.clone();

    $newPattern.removeClass('defaultPatternContainer').addClass('repeaterPatternContainer').show();
    $newPattern.find('input[name^="mappingPatternValue"]').val('').attr('name', `mappingPatternValue[${catIndex}][]`);
    $newPattern.find('select[name^="mappingPatternField"]').val('').addClass('select2MappingPatternField').attr('name', `mappingPatternField[${catIndex}][]`);
    $newPattern.find('.removePatterContainer').show().find('button').show();

    $(this).prev().append($newPattern);

    $newPattern.find('.select2MappingPatternField').select2({
      placeholder: $(this).data('placeholder'),
      minimumResultsForSearch: Infinity,
    });

    makeKTBlock('#utmmappingForm', 'hide');
  });

  const reindexCategories = () => {
    $('#utmmappingForm').find('.defaultPatternContainer').attr('data-category-index', 0);
    $('.repeaterUTMContainer').each(function (newIndex) {
      var tempIndex = newIndex;
      $(this).attr('data-category-index', tempIndex);

      // Reindex all pattern value inputs
      $(this)
        .find('select[name^="mappingPatternField"]')
        .each(function () {
          $(this).attr('name', `mappingPatternField[${tempIndex}][]`);
        });

      $(this)
        .find('input[name^="mappingPatternValue"]')
        .each(function () {
          $(this).attr('name', `mappingPatternValue[${tempIndex}][]`);
        });
    });
  };

  $(document).on('click', '.removePatterContainer', function (e) {
    e.preventDefault();
    makeKTBlock('#utmmappingForm');

    $(this).parent().remove();
    reindexCategories();
    makeKTBlock('#utmmappingForm', 'hide');
  });
  //   Eol Listener Pattern value

  //   Listener UTM Mapping
  $('#btnAddUTMMapping').on('click', function (e) {
    e.preventDefault();
    makeKTBlock('#utmmappingForm');

    // Clone container UTM First
    let $dupeElemUTM = $('.defaultUTMContainer').clone();

    $dupeElemUTM.removeClass('defaultUTMContainer').addClass('repeaterUTMContainer').show();
    $dupeElemUTM.find('.removeContainer').show();
    $dupeElemUTM.find('.removeContainer').find('button').show();

    $('.addContainer').before($dupeElemUTM);

    // Clone Patter Value content
    let $patternTemplate = $('.defaultPatternContainer').clone();
    $patternTemplate.removeClass('defaultPatternContainer').addClass('repeaterPatternContainer').show();
    $patternTemplate.find('.removePatterContainer').show().find('button').show();
    $patternTemplate
      .find('select[name="mappingPatternField[][]"]')
      .addClass('select2MappingPatternField')
      .select2({ placeholder: $(this).data('placeholder'), minimumResultsForSearch: Infinity });

    $dupeElemUTM.find('.defaultPatternValueContainer').append($patternTemplate);
    makeKTBlock('#utmmappingForm', 'hide');
  });

  $('#btnCopyUTMMapping').on('click', function (e) {
    e.preventDefault();
    makeKTBlock('#utmmappingForm');

    const $origContainerLast = $('.repeaterUTMContainer').last();
    const $origSelect = $origContainerLast.find('.select2MappingPatternField');
    const selectedVal = $origSelect.val();

    // Clone the container
    const $dupeElemUTM = $origContainerLast.clone(false);

    // Remove any old select2 container markup inside the clone
    $dupeElemUTM.find('.select2-container').remove();

    // Get the select inside the clone (not the original!)
    const $clonedSelect = $dupeElemUTM.find('.select2MappingPatternField');

    // Update its name/index so it’s unique
    const newIndex = $('.repeaterUTMContainer').length; // how many containers before adding
    $clonedSelect.attr('name', `mappingPatternField[${newIndex}][]`);

    // Append clone into DOM
    $('.addContainer').before($dupeElemUTM);

    // Initialize select2 on the cloned select
    $clonedSelect
      .removeAttr('data-select2-id')
      .removeClass('select2-hidden-accessible')
      .select2({
        placeholder: 'choose',
        width: '100%',
      })
      .val(selectedVal)
      .trigger('change');

    makeKTBlock('#utmmappingForm', 'hide');
  });

  $(document).on('click', '.btnRemoveUTMMapping', function (e) {
    e.preventDefault();
    makeKTBlock('#utmmappingForm');

    Swal.fire({
      title: 'Are you sure want to remove this UTM Mapping?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it.',
      customClass: {
        confirmButton: 'btn btn-sm btn-primary',
        cancelButton: 'btn btn-sm btn-light-danger',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        $(this).parents('.repeaterUTMContainer').remove();
        reindexCategories();
      }
    });

    makeKTBlock('#utmmappingForm', 'hide');
  });
  //   Eol Listener UTM Mapping

  $('#selectEventDupe').on('change', function (e) {
    e.preventDefault();

    makeKTBlock('#formDupeUTMMapping');
    let value = $(this).val();
    $.ajax({
      url: `${BASE_URL}C_Event/checkEventUTM?eid=${getUrlParameter('id')}`,
      method: 'POST',
      dataType: 'json',
      data: { event_id: value },
      success: function (resp) {
        const { header, message, status } = resp;
        makeKTBlock('#formDupeUTMMapping', 'hide');

        $('#formDupeUTMMapping').find('button[type="submit"]').attr('disabled', false);
      },
      error: function (data) {
        const { header, message, status } = data.responseJSON;
        makeKTBlock('#formDupeUTMMapping', 'hide');
        makeSwal(header, message, status);

        $('#formDupeUTMMapping').find('button[type="submit"]').attr('disabled', true);
      },
    });
  });

  $('#formDupeUTMMapping').on('submit', function (e) {
    e.preventDefault();

    makeKTBlock('#formDupeUTMMapping');
    $.ajax({
      url: `${BASE_URL}C_Event/dupeUTMMapping?eid=${getUrlParameter('id')}`,
      method: 'post',
      dataType: 'JSON',
      data: $(this).serialize(),
      success: function (resp) {
        const { header, message, status } = resp;
        makeKTBlock('#formDupeUTMMapping', 'hide');
        makeSwal(header, message, status, 'action', '385px', 'reload');
      },
      error: function (data) {
        const { header, message, status } = data.responseJSON;
        makeKTBlock('#formDupeUTMMapping', 'hide');
        makeSwal(header, message, status);
      },
    });
  });

  $('#btnResetUTMMapping').on('click', function (e) {
    e.preventDefault();
    makeKTBlock('#utmmappingForm');

    Swal.fire({
      title: 'Are you sure want to reset all UTM Mapping this event?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it.',
      customClass: {
        confirmButton: 'btn btn-sm btn-primary',
        cancelButton: 'btn btn-sm btn-light-danger',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        $.ajax({
          url: `${BASE_URL}C_Event/resetUTMMapping?eid=${getUrlParameter('id')}`,
          method: 'GET',
          dataType: 'JSON',
          success: function (resp) {
            const { header, message, status } = resp;
            makeKTBlock('#utmmappingForm', 'hide');
            makeSwal(header, message, status, 'action', '385px', 'reload');
          },
          data: function (data) {
            const { header, message, status } = data;
            makeSwal(header, message, status);
          },
        });
      } else {
        makeKTBlock('#utmmappingForm', 'hide');
      }
    });
  });

  $('#utmmappingForm').on('submit', function (e) {
    e.preventDefault();

    makeKTBlock('#utmmappingForm');
    reindexCategories();

    setTimeout(() => {
      $.ajax({
        url: `${BASE_URL}C_Event/UTMMappingStore?eid=${getUrlParameter('id')}`,
        method: 'POST',
        dataType: 'JSON',
        data: $(this).serialize(),
        success: function (resp) {
          const { header, message, status, code } = resp;
          makeKTBlock('#utmmappingForm', 'hide');
          if (code == 200) {
            makeSwal(header, message, status, 'action', '385px', 'reload-tab#utmmapping');
          } else {
            makeSwal(header, message, status);
          }
        },
        error: function (data) {
          const { header, message, status, code } = data.responseJSON;
          makeKTBlock('#utmmappingForm', 'hide');
          makeSwal(header, message, status);
        },
      });
    }, 2000);
  });
};

export { utmMappingListener };
